
import {
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaLinkedinIn,
    FaWhatsapp,
    
} from "react-icons/fa";

function Footer() {
    //const [email, setEmail] = useState("");

    return (
        <footer className="bg-slate-950 text-slate-300 mt-12 glossy-footer">

            <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">

                {/* =================================================
                    ABOUT
                ================================================== */}
                <div>

                    <h4 className="text-2xl font-bold text-white">
                        Nexus Mental Health
                    </h4>

                    <p className="mt-3 text-sm text-slate-400">
                        We connect people with licensed therapists,
                        community programs, and wellness resources
                        to support mental health at every stage of life.
                    </p>

                    <p className="mt-4 text-xs text-slate-500">
                        © 2026 Nexus Mental Health Foundation
                    </p>

                </div>


                {/* =================================================
                    LINKS
                ================================================== */}
                <div>

                    <h5 className="font-semibold text-white mb-3">
                        Links
                    </h5>

                    <ul className="space-y-2 text-sm text-slate-400">

                        <li>
                            <a
                                href="/faqs"
                                className="hover:text-cyan-400 transition"
                            >
                                FAQs
                            </a>
                        </li>

                        <li>
                            <a
                                href="/contact"
                                className="hover:text-cyan-400 transition"
                            >
                                Contact Us
                            </a>
                        </li>

                        <li>
                            <a
                                href="/careers"
                                className="hover:text-cyan-400 transition"
                            >
                                Careers
                            </a>
                        </li>

                        <li>
                            <a
                                href="/privacy"
                                className="hover:text-cyan-400 transition"
                            >
                                Privacy Policy
                            </a>
                        </li>

                        <li>
                            <a
                                href="/terms"
                                className="hover:text-cyan-400 transition"
                            >
                                Terms of Service
                            </a>
                        </li>

                    </ul>

                </div>


                {/* =================================================
                    RESOURCES
                ================================================== */}
                <div>

                    <h5 className="font-semibold text-white mb-3">
                        Resources
                    </h5>

                    <ul className="space-y-2 text-sm text-slate-400">

                        <li>
                            <a
                                href="/blog"
                                className="hover:text-cyan-400 transition"
                            >
                                Blog
                            </a>
                        </li>

                        <li>
                            <a
                                href="/events"
                                className="hover:text-cyan-400 transition"
                            >
                                Events
                            </a>
                        </li>

                        <li>
                            <a
                                href="/programs"
                                className="hover:text-cyan-400 transition"
                            >
                                Wellness Programs
                            </a>
                        </li>

                        <li>
                            <a
                                href="/support"
                                className="hover:text-cyan-400 transition"
                            >
                                Support Services
                            </a>
                        </li>

                    </ul>

                </div>


                {/* =================================================
                    SOCIAL MEDIA
                ================================================== */}
                <div>

                    <h5 className="font-semibold text-white mb-3">
                        Follow Nexus
                    </h5>

                    <p className="text-sm text-slate-400 mb-4">
                        Connect with Nexus Mental Health Foundation
                        on social media.
                    </p>


                    <div className="flex flex-wrap gap-3">

                        {/* Facebook */}
                        <a
                            href="https://facebook.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                            className="
                                flex h-10 w-10
                                items-center justify-center
                                rounded-full
                                bg-slate-800
                                text-slate-300
                                shadow-md
                                transition-all duration-300
                                hover:-translate-y-1
                                hover:bg-blue-600
                                hover:text-white
                                hover:shadow-lg
                            "
                        >
                            <FaFacebookF size={17} />
                        </a>


                        {/* Instagram */}
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            className="
                                flex h-10 w-10
                                items-center justify-center
                                rounded-full
                                bg-slate-800
                                text-slate-300
                                shadow-md
                                transition-all duration-300
                                hover:-translate-y-1
                                hover:bg-pink-600
                                hover:text-white
                                hover:shadow-lg
                            "
                        >
                            <FaInstagram size={19} />
                        </a>


                        {/* YouTube */}
                        <a
                            href="https://youtube.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="YouTube"
                            className="
                                flex h-10 w-10
                                items-center justify-center
                                rounded-full
                                bg-slate-800
                                text-slate-300
                                shadow-md
                                transition-all duration-300
                                hover:-translate-y-1
                                hover:bg-red-600
                                hover:text-white
                                hover:shadow-lg
                            "
                        >
                            <FaYoutube size={19} />
                        </a>


                        {/* LinkedIn */}
                        <a
                            href="https://linkedin.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            className="
                                flex h-10 w-10
                                items-center justify-center
                                rounded-full
                                bg-slate-800
                                text-slate-300
                                shadow-md
                                transition-all duration-300
                                hover:-translate-y-1
                                hover:bg-blue-700
                                hover:text-white
                                hover:shadow-lg
                            "
                        >
                            <FaLinkedinIn size={17} />
                        </a>


                        {/* WhatsApp */}
                        <a
                            href="https://wa.me/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="WhatsApp"
                            className="
                                flex h-10 w-10
                                items-center justify-center
                                rounded-full
                                bg-slate-800
                                text-slate-300
                                shadow-md
                                transition-all duration-300
                                hover:-translate-y-1
                                hover:bg-green-500
                                hover:text-white
                                hover:shadow-lg
                            "
                        >
                            <FaWhatsapp size={19} />
                        </a>


                       
                    </div>

                </div>

            </div>


            {/* =================================================
                BOTTOM BAR
            ================================================== */}
            <div className="border-t border-slate-800">

                <div className="
                    max-w-7xl mx-auto
                    px-6 py-4
                    text-xs text-slate-600
                    flex flex-col
                    md:flex-row
                    justify-between
                    items-center
                    gap-4
                ">

                    <div>
                        Made with care • Nexus Mental Health Foundation
                    </div>

                    <div className="flex gap-4">

                        <a
                            href="/sitemap.xml"
                            className="hover:text-cyan-400 transition"
                        >
                            Sitemap
                        </a>

                        <a
                            href="/accessibility"
                            className="hover:text-cyan-400 transition"
                        >
                            Accessibility
                        </a>

                        <a
                            href="/contact"
                            className="hover:text-cyan-400 transition"
                        >
                            Contact
                        </a>

                    </div>

                </div>

            </div>

        </footer>
    );
}

export default Footer;